//Teams
export const releaseDateV2 = new Date('2024-05-14');
//New pricing plan and Youtube widget
export const releaseDateV3 = new Date('2024-09-11');
